export default {
      id: "steemit-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#steemit",
      toString: function () {
        return this.url;
      }
    }